import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _UBLInvoice } from "../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../theme/Component/usePaginator";
import { totalmem } from "node:os";
import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";


interface Props {
    idUBLInvoice: number;
}

export const UBLEventsInvoiceEmail = ({ idUBLInvoice }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_UBLInvoice);
    const paginador = usePaginator();

    useEffect(() => {
        if (idUBLInvoice) {
            getLista();
        }
    }, [idUBLInvoice])

    const getLista = () => {

        instance.eventsInvoiceEmail(paginador.page, 15, { ClassForName: "com.quickdataerp.bean.ubl.UBLInvoice", IDUBLInvoice: idUBLInvoice }).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const head = [
        { title: 'ID', property: 'IDUBLEmails', visible: true },
        { title: 'Correo', property: 'Email', visible: true },
        { title: 'Código', property: 'StatusCode', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Enviado Por', property: 'EmployeeName', visible: true },
    ]


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} />
            </div>
        </div>
    )
}